import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import YourAvatarHolder from './YourAvatarHolder';
import Airtable from 'airtable';
import queryString from 'query-string';
import Collection from './Collection';
import { getAvatarDetails } from '../utils';

const Holder = styled.div`
  margin-bottom: 4rem;
`;

function MyAvatarsHolder( { location } ) {
  const [ avatars, setAvatars ] = useState( [] );
  const [ noResults, setNoResults ] = useState( [ false ] );
  const [ loading, setLoading ] = useState( [ true ] );

  useEffect( () => {
    setLoading( true );
    const base = new Airtable( { apiKey: `${process.env.REACT_APP_AIRTABLE_API_KEY}` } ).base( 'appJ4XWmflOm4QY2P' );
    base( 'User responses' ).select( {
      // Selecting the first 3 records in Grid view:
      maxRecords: 3,
      view: 'Grid view',
      filterByFormula: `SEARCH(RECORD_ID(), "${queryString.parse(location.search).ids}") != ""`,
    } ).eachPage( function page( records, fetchNextPage ) {
      // This function (`page`) will get called for each page of records.

      if ( records.length > 0 ) {
        records.forEach( function ( record ) {
          console.log( 'Retrieved', record.getId() );
        } );
        setAvatars( records );
        setNoResults( false );
      } else {
        setNoResults( true );
      }

      setLoading( false );
      // To fetch the next page of records, call `fetchNextPage`.
      // If there are more records, `page` will get called again.
      // If there are no more records, `done` will get called.
      fetchNextPage();

    }, function done( err ) {
      if ( err ) {
        console.error( err );
        setLoading( false );
        setNoResults( true );
      }
    } );
  }, [ location ] );


  if ( loading ) { return (<p>Loading...</p>) }
  if ( noResults ) { return (<p>Sorry, we couldn't find those avatars you're looking for.</p>) }

  return (
    <>
      {avatars.map( avatar => (
        <Holder key={avatar.getId()}>
          <YourAvatarHolder
            currentAvatar={avatar.fields.prefix}
            features={avatar.fields}/>
          <h1>Avatar {getAvatarDetails(avatar.fields.prefix).id}</h1>
          <h4 className="regular"><strong className="highlight-yellow">Compare this
            avatar</strong> with others from around the world.</h4>
          <Collection avatarPrefix={avatar.fields.prefix} limit={2}/>
        </Holder>
      ) )}
    </>
  )
}

export default withRouter( MyAvatarsHolder );
